import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import image from '../assets/img/firstsetp-im.png';
import { handleSubmission } from '../assets/resource/infoFormFun';

const plan = ['Free consult', 'Basic', 'Standard', 'Pro', 'Custom'];

const StyledForm = styled(Box)(({ theme }) => ({
  '& > :not(style)': {
    margin: '6px 0',
    width: '100%',
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': { padding: '10px 8px', color: '#F6F6F6' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#888888' },
  '& .MuiTextField-root > .MuiOutlinedInput-notchedOutline': { borderColor: '#888888' },
  '& .MuiFormLabel-root': { color: '#888888' },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#F6F6F6' },
  '& .MuiFormLabel-root.Mui-focused': { color: '#F6F6F6' },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F6F6F6' },
  '& .MuiInputLabel-shrink': { transform: 'translate(14px, -6px) scale(0.75)', color: '#F6F6F6' },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  color: '#0A0A0A',
  fontWeight: '600',
  '&:hover': { color: '#FFFFFF', backgroundColor: '#141414' },
}));

const MyForm = ({
  name, setName, email, setEmail, phoneNo, setPhoneNo, busType, setBusType,
  packageType, setPackageType, packag, packFunc, plan, busWebsite, setBusWebsite,
  errors, handleSubmitEvent, submissionMsg
}) => (
  <StyledForm
    component="form"
    noValidate
    autoComplete="off"
    onSubmit={handleSubmitEvent}
  >
    <StyledTextField
      required
      id="outlined-full-name"
      label="Full Name (surname first)"
      name="Full Name"
      variant="outlined"
      value={name}
      onChange={e => setName(e.target.value)}
      error={!!errors.name}
      helperText={errors.name}
    />
    <StyledTextField
      required
      id="outlined-email"
      label="Email"
      name="Email"
      type="email"
      variant="outlined"
      value={email}
      onChange={e => setEmail(e.target.value)}
      error={!!errors.email}
      helperText={errors.email}
    />
    <StyledTextField
      required
      id="outlined-phone"
      label="Phone Number"
      name="Phone Number"
      variant="outlined"
      value={phoneNo}
      onChange={e => setPhoneNo(e.target.value)}
      error={!!errors.phoneNo}
      helperText={errors.phoneNo}
    />
    <StyledTextField
      required
      id="outlined-bus-type"
      label="Type Of Business"
      name="Type Of Business"
      variant="outlined"
      value={busType}
      onChange={e => setBusType(e.target.value)}
      error={!!errors.busType}
      helperText={errors.busType}
    />
    <Autocomplete
      id="controllable-states-demo"
      value={packageType}
      onChange={(e, newValue) => setPackageType(newValue)}
      inputValue={packag}
      onInputChange={(e, value) => packFunc(value)}
      options={plan}
      sx={{
        margin: '6px 0',
        '& .MuiInputBase-input': { padding: '10px 8px', color: '#F6F6F6' },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#888888' },
        '& .MuiFormLabel-root': { color: '#888888', transform: 'translate(14px, 20px) scale(1)' },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#F6F6F6' },
        '& .MuiFormLabel-root.Mui-focused, .MuiAutocomplete-popupIndicator': { color: '#F6F6F6', padding: '0' },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F6F6F6' },
        '& .MuiIconButton-root-MuiAutocomplete-popupIndicator': { color: '#F6F6F6' },
        '& .MuiAutocomplete-root .MuiOutlinedInput-root': { padding: '0px' },
        '& .MuiInputLabel-shrink': { transform: 'translate(14px, -6px) scale(0.75)', color: '#F6F6F6' },
      }}
      renderInput={params => (
        <StyledTextField
          {...params}
          name="Type Of Package"
          required
          label="Type Of Package"
          error={!!errors.package}
          helperText={errors.package}
        />
      )}
    />
    <StyledTextField
      id="outlined-bus-website"
      label="Business Website"
      variant="outlined"
      value={busWebsite}
      onChange={e => setBusWebsite(e.target.value)}
    />
    <StyledButton
      variant="contained"
      type="submit"
      disabled={submissionMsg.split('-')[0] === 'pass'}
    >
      Submit
    </StyledButton>
    {submissionMsg && (
      <small
        className={`block text-center capitalize font-medium ${
          submissionMsg.split('-')[0] === 'pass' ? 'text-green-600' : 'text-red-600'
        }`}
      >
        {submissionMsg.split('-')[1]}
      </small>
    )}
  </StyledForm>
);

export const OptInSection = ({ packag, packFunc }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [busType, setBusType] = useState('');
  const [packageType, setPackageType] = useState(null);
  const [busWebsite, setBusWebsite] = useState('');
  const [errors, setErrors] = useState({});
  const [submissionMsg, setSubmissionMsg] = useState('');

  const cleanSlate = () => {
    setName('');
    setEmail('');
    setPhoneNo('');
    setBusType('');
    setPackageType(null);
    setBusWebsite('');
    packFunc('');
  };

  const validateForm = () => {
    const errors = {};

    if (!name.trim()) {
      errors.name = 'Name is required';
    }

    if (!email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email is invalid';
    }
    if (!phoneNo.trim()) {
      errors.phoneNo = 'Phone Number is required';
    } else if (isNaN(Number(phoneNo.trim()))) {
      errors.phoneNo = 'Phone Number is invalid';
    }
    if (!busType.trim()) {
      errors.busType = 'Business Type is required';
    }
    if (!packag && !packageType) {
      errors.package = 'Pick a package';
    }

    setErrors(errors);
    return Object.keys(errors).length;
  };

  const handleSubmitEvent = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (errors < 1) {
      let entry = {
        clientName: name,
        clientEmail: email,
        clientPhonNo: phoneNo,
        clientBusType: busType,
        clientPackage: packageType ? packageType : packag,
        clientWebSite: busWebsite,
      };
      await handleSubmission(entry, setSubmissionMsg, cleanSlate);
    }
  };

  return (
    <section className="mainWrapper min-h-fit flex flex-col items-center justify-center py-[10vh] gap-10">
      <h4 className="header capitalize font-medium text-[var(--text-h)]" style={{ textShadow: '2px 2px 5px rgba(0, 0, 0, 1)' }}>
        Take first step
      </h4>
      <h6 className="subheader text-center">
        Ready to revolutionize your digital presence? Join the ranks of visionary businesses thriving with Fade. Let's embark on a journey of digital innovation together – ignite your brand's future today!
      </h6>
      <div className="formArea flex flex-col md:flex-row items-center gap-10">
        <div className="sm:w-[60%] md:flex-1">
          <img src={image} alt="" />
        </div>

        <div className="md:flex-1" id="opt-in">
          <MyForm
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            phoneNo={phoneNo}
            setPhoneNo={setPhoneNo}
            busType={busType}
            setBusType={setBusType}
            packageType={packageType}
            setPackageType={setPackageType}
            packag={packag}
            packFunc={packFunc}
            plan={plan}
            busWebsite={busWebsite}
            setBusWebsite={setBusWebsite}
            errors={errors}
            handleSubmitEvent={handleSubmitEvent}
            submissionMsg={submissionMsg}
          />
        </div>
      </div>
    </section>
  );
};
